import React from "react";
import SalesPromotionsPage from "./SalesPromotionsPage";


export default function PromoCodesPage(props){

  return(<SalesPromotionsPage promocodes />);
  
}